<router-outlet></router-outlet>
<p-toast [baseZIndex]='10000' position="bottom-right"></p-toast>
<ngx-ui-loader [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>
<ng-template #foregroundSpinner>
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8"
    animationDuration=".5s"></p-progressSpinner>
</ng-template>